/**
 * Marketing consent checkbox: Ninja Forms renders the text as a field
 * description (not a <label>), so make a click on it toggle the checkbox.
 */
$( document ).on( 'click', '.checkbox-consent-container .nf-field-description', function( event ) {
	if ( $( event.target ).closest( 'a' ).length ) {
		return;
	}

	$( this ).closest( '.checkbox-wrap' ).find( 'input[type="checkbox"]' ).trigger( 'click' );
} );
